/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
        if ($('#agree_agb').is(':checked') && $('#agree_widerruf').is(':checked')) {
            $(this).submit();
        }
        else {
            alert("Bitte akzeptieren Sie unsere Bedingungen, bevor Sie Ihren Kauf fortsetzen.");
            return false;
        }
    });
    $('body').on('click', '[name="contact-submit"]', function () {
        if ($('#agree_contact').is(':checked')) {
            $(this).submit();
        }
        else {
            alert("Bitte akzeptieren Sie unsere Datenschutzhinweise, bevor Sie Ihre Nachricht absenden.");
            return false;
        }
    });

    if (window.location.pathname == '/') {
        $('section[data-custom-class="home-video"] .home-video').click(function () {
            $('section[data-custom-class="home-video"] .home-video').hide();
            $('section[data-custom-class="home-video"] .home-video.youtube').show();
            $('section[data-custom-class=home-video] .responsive-video iframe')[0].src += "?autoplay=1";
        })
    }
});
